import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { PRIORITY_TASK_PROGRESS_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_PRIORITY_TASK_PROGRESS_COUNTS } from '../redux/action-types'

const usePriorityTaskProgressCountsLazyQuery = () => {
  const dispatch = useDispatch()

  const data = useSelector(
    store =>
      store.menuCurationTasks.menuCurationTasks.priorityTaskProgressCounts,
  )

  const fetch = useCallback(
    () =>
      apolloService.query({
        query: PRIORITY_TASK_PROGRESS_COUNTS_QUERY,
        dispatch,
        action: FETCH_PRIORITY_TASK_PROGRESS_COUNTS,
      }),
    [dispatch],
  )

  return [fetch, { data }]
}

export default usePriorityTaskProgressCountsLazyQuery
